( function( $ ) {
	'use strict';

	const mobileBreakpoint = window.matchMedia( '(max-width: 1301px)' );
	const langTrigger = $( '.lang-selector__trigger' );
	const langList = $( '.lang-selector__list' );
	const activeClass = 'lang-selector--active';

	if( mobileBreakpoint.matches ) {
		langTrigger.addClass( 'js-accordion__toggle' );
		langList.addClass( 'js-accordion__content' );
	} else {
		langTrigger.on( 'click', function() {
			$( this ).parent().toggleClass( activeClass );
		} );
	}

	$( '.lang-selector__item' ).on( 'click', function () {
		var itemValue = $( this ).text();
		$( '.lang-selector__item--selected' ).text( itemValue );
	} );

	/*
	*	Close dropdown with click off
	*/
	$( document ).mouseup( function ( e ) {
		var container = $( '.lang-selector' );
		if ( !container.is( e.target )
			&& 0 === container.has( e.target ).length )
		{
			container.removeClass( 'lang-selector--active' );
		}
	} );

} )( jQuery );
